(function () {
  function initPlpNavBarIndicator() {
    var activeLink = document.querySelector('.plp-nav-bar__link--active');
    var nav = activeLink ? activeLink.closest('.plp-nav-bar__nav') : null;
    if (!nav || !activeLink) return;

    var list = nav.querySelector('.plp-nav-bar__list');
    if (!list) return;

    var indicator = list.querySelector('.plp-nav-bar__indicator');

    function getOffsetInList() {
      var listRect = list.getBoundingClientRect();
      var linkRect = activeLink.getBoundingClientRect();
      var left = linkRect.left - listRect.left + list.scrollLeft;
      var width = Math.max(linkRect.width, 1);
      return { left: left, width: width };
    }

    if (!indicator) {
      var pos = getOffsetInList();
      indicator = document.createElement('div');
      indicator.setAttribute('class', 'plp-nav-bar__indicator plp-nav-bar__indicator--ready');
      indicator.setAttribute('aria-hidden', 'true');
      indicator.style.left = pos.left + 'px';
      indicator.style.width = pos.width + 'px';
      list.appendChild(indicator);
    }

    function positionIndicator() {
      var pos = getOffsetInList();
      indicator.style.left = pos.left + 'px';
      indicator.style.width = pos.width + 'px';
    }

    positionIndicator();
    window.addEventListener('resize', positionIndicator);
  }

  function tryInit() {
    if (document.querySelector('.plp-nav-bar__link--active')) {
      initPlpNavBarIndicator();
    }
  }

  tryInit();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  }
  window.addEventListener('load', tryInit);
  setTimeout(tryInit, 300);
})();
